import React, { FunctionComponent } from 'react';
import { InfoIcon } from '../SvgIcons';

// Import Local Styles
import styles from './infoBanner.module.css';

export interface AlertBannerProps {
  text: string;
}

export const InfoBanner: FunctionComponent<AlertBannerProps> = (props) => {
  const { text } = props;

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.message}>
          <InfoIcon />
          {text}
        </div>
      </div>
    </>
  );
};
